import { Token } from '@uniswap/sdk-core';

// Chain ID for Sepolia testnet
export const CHAIN_ID = 11155111;

// Common tokens
export const WETH = new Token(
  CHAIN_ID,
  '0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9', // Sepolia WETH
  18,
  'WETH',
  'Wrapped Ether'
);

export const USDC = new Token(
  CHAIN_ID,
  '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
  6,
  'USDC',
  'USD Coin'
);

export const DAI = new Token(
  CHAIN_ID,
  '0x6B175474E89094C44Da98b954EedeAC495271d0F',
  18,
  'DAI',
  'Dai Stablecoin'
);

export const USDT = new Token(
  CHAIN_ID,
  '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  6,
  'USDT',
  'Tether USD'
);

export const WBTC = new Token(
  CHAIN_ID,
  '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  8,
  'WBTC',
  'Wrapped Bitcoin'
);

// Add your custom tokens
export const TOKEN_A = new Token(
  CHAIN_ID,
  '0xA8CFDC4Caf8F5baC6A67dbBE7405CCe30175557b',
  18,
  'TKNA',
  'Token A'
);

export const TOKEN_B = new Token(
  CHAIN_ID,
  '0xCe804991d254f070B9566882C9cB46049612b0a1',
  18,
  'TKNB',
  'Token B'
);

// Token list for selection
export const TOKEN_LIST = [TOKEN_A, TOKEN_B];

// Infura API key - replace with your own
export const INFURA_KEY = 'YOUR_INFURA_KEY';

// Provider URL for Sepolia
export const PROVIDER_URL = `https://sepolia.infura.io/v3/727b0978983d4eb3b7ecc93e2d59c8a1`;

// SimpleSwap contract address
export const SIMPLE_SWAP_ADDRESS = '0x0fdd00A7Ece185Cc764D0591836512Adcd4a1e4a';

// Uniswap V3 addresses for Sepolia
export const SWAP_ROUTER_ADDRESS = '0xE592427A0AEce92De3Edee1F18E0157C05861564';

// V3 Factory address (Your deployed liquidity pool factory)
export const LIQUIDITY_POOL_ADDRESS = '0xbc16C10737ffE67E5274a6D27c202F2371bEaB9c';

// Uniswap V3 Position Manager address on Sepolia
export const POSITION_MANAGER_ADDRESS = '0x1238536071E1c677A632429e3655c799b22cDA52';